var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70732 0H18.2927C22.0274 0 25 3.06748 25 6.74847V18.2515C25 22.0092 21.9512 25 18.2927 25H6.70732C2.97256 25 0 21.9325 0 18.2515V6.74847C0 3.06748 3.04878 0 6.70732 0ZM19.2073 4.37117C19.9695 4.37117 20.6555 5.06135 20.6555 5.82822C20.6555 6.59509 19.9695 7.28528 19.2073 7.28528C18.3689 7.28528 17.7591 6.59509 17.7591 5.82822C17.7591 5.06135 18.3689 4.37117 19.2073 4.37117ZM12.5 5.67485C16.2348 5.67485 19.3598 8.81902 19.3598 12.5C19.3598 16.2577 16.2348 19.3252 12.5762 19.3252H12.5C8.76524 19.3252 5.79268 16.2577 5.79268 12.5C5.71646 8.81902 8.76524 5.67485 12.5 5.67485ZM12.5 8.05215C15.0152 8.05215 16.997 10.1227 16.997 12.5767C16.997 15.1074 14.939 17.1012 12.5 17.1012H12.4238C9.98476 17.1012 7.92683 15.0307 7.92683 12.5767C8.00305 10.046 9.98476 8.05215 12.5 8.05215ZM6.78354 2.14724H18.1402C20.7317 2.14724 22.7896 4.21779 22.7896 6.82515V18.2515C22.7896 20.8589 20.7317 22.9294 18.1402 22.9294H6.78354C4.19207 22.9294 2.13415 20.8589 2.13415 18.2515V6.82515C2.13415 4.29448 4.26829 2.14724 6.78354 2.14724Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.0979fe4311393caf2367673d5a9c59f9.svg";
export { ForwardRef as ReactComponent };